/**
 * Post-OAuth callback paths for third-party connector flows.
 *
 * Each value is a Django URL route name; after a connector's OAuth handshake
 * completes the backend reverses the value to a URL and redirects the customer
 * back to it. The backend validates the incoming `callbackPath` against the
 * canonical registry in `core/connectors/callback_paths.py`, so values here must
 * stay in sync with a route that exists server-side.
 */
export enum AuthCallbackPath {
  FUNDING_APPLICATION = "funding-application:funding-application-connections", // Default
  FUNDING_APPLICATION_ADD_CONNECTION = "funding-application:funding-application-connections-add",
  FUNDING_APPLICATION_AIRS_REVIEW = "funding-application:funding-application-connections-airs-review",
  FUNDING_APPLICATION_BANKING = "funding-application:funding-application-connections-banking",
  CUSTOMER_HOME = "funding-application:funding-application-home-connection",
  ADDITIONAL_FUNDING_TASK_AIR_CONNECTION = "funding-application:additional-funding-application-customer-task-air-connection",
  COMPANY_CONNECTIONS = "settings-company-connections",
}
